import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { KnBrInvoiceListDetailOverviewComponent } from './kn-br-invoice-list-detail-overview.component';
import { KnBrCommonAddressModule } from '../../kn-br-common-address/kn-br-common-address.module';

@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        MediaModule,
        KnBrCommonAddressModule,
        ConfigModule.withConfig({
            cmsComponents: {
                CarlisleInvoiceDetailsHeaderComponent: {
                    component: KnBrInvoiceListDetailOverviewComponent,
                },
            },
        } as CmsConfig),
        KnBrInvoiceListDetailOverviewComponent,
    ],
})
export class KnBrInvoiceDetailsOverviewModule {}
